import { BaseEntitiesService } from './BaseEntitiesService';
import { BookmarksRepository, TopicGroupMapsRepository } from '../repositories/bm';
import { createObjectsCache } from '../singleton';
export class BookmarksService extends BaseEntitiesService {
    topic_id;
    constructor(topic_id) {
        super(new BookmarksRepository(topic_id));
        this.topic_id = topic_id;
    }
    _dispose() {
        BookmarksService._cache.remove(this.topic_id);
        super._dispose();
    }
    static _cache = createObjectsCache((topic_id) => new BookmarksService(topic_id), '__bm_bookmarks');
    static createInstance = BookmarksService._cache.get;
}
export class TopicGroupMapsService extends BaseEntitiesService {
    topic_id;
    constructor(topic_id) {
        super(new TopicGroupMapsRepository(topic_id));
        this.topic_id = topic_id;
    }
    _dispose() {
        TopicGroupMapsService._cache.remove(this.topic_id);
        super._dispose();
    }
    static _cache = createObjectsCache((topic_id) => new TopicGroupMapsService(topic_id), '__bm_topic_group_maps');
    static createInstance = TopicGroupMapsService._cache.get;
}
